import React from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useNotify, useRefresh } from 'react-admin';

import useSupplyStyles from '../controls/SupplyStyles';
import supplyPost from '../controls/supplyApi';

/**
 * The status / qty / action grid on the receipt screen.
 * Each row's action is the next legal move for that bucket.
 */
const InventoryTable = ({ record }) => {
    const classes = useSupplyStyles();
    const notify = useNotify();
    const refresh = useRefresh();

    if (!record) { return null; }

    const post = (path, body, okMessage) => {
        supplyPost(`supplyreceipts/${record.id}/${path}`, body)
            .then(() => {
                notify(okMessage);
                refresh();
            })
            .catch(error => {
                notify(
                    (error && error.body) || (error && error.message) || 'Action failed',
                    'warning'
                );
            });
    };

    const rows = [
        {
            key: 'qa',
            label: 'QA Pending',
            qty: record.qty_qa_pending,
            action: record.qty_qa_pending > 0
                ? {
                    label: 'QA Approve',
                    run: () => post('qaapprove', { qty: record.qty_qa_pending }, 'QA approved'),
                }
                : null,
        },
        {
            key: 'reserve',
            label: 'Reserve',
            qty: record.qty_reserve,
            action: record.qty_reserve > 0
                ? {
                    label: 'Release',
                    run: () => post('release', { qty: record.qty_reserve }, 'Released'),
                }
                : null,
        },
        {
            key: 'release',
            label: 'Release',
            qty: record.qty_release,
            action: record.qty_release > 0
                ? { label: 'Consume', run: () => post('consume', { qty: 1 }, 'Consumed 1') }
                : null,
        },
    ];

    if (record.has_sublots) {
        rows.push({
            key: 'relsublot',
            label: 'Release (Open Sublot)',
            qty: record.qty_rel_sublot,
            action: null,
        });
    }

    rows.push({ key: 'transfer', label: 'Transfer', qty: record.qty_transfer, action: null });
    rows.push({ key: 'hold', label: 'Hold', qty: record.qty_hold, action: null });

    const total = (record.qty_qa_pending || 0) + (record.qty_reserve || 0) + (record.qty_release || 0)
        + (record.qty_rel_sublot || 0) + (record.qty_transfer || 0) + (record.qty_hold || 0);

    return (
        <React.Fragment>
            <Typography className={classes.sectionTitle}>Inventory</Typography>
            <Table size="small">
                <TableHead className={classes.tableHead}>
                    <TableRow>
                        <TableCell className={classes.tableHeadCell}>Status</TableCell>
                        <TableCell className={classes.tableHeadCell}>Qty</TableCell>
                        <TableCell className={classes.tableHeadCell}>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.key}>
                            <TableCell>{row.label}</TableCell>
                            <TableCell>{row.qty || 0}</TableCell>
                            <TableCell>
                                {row.action ? (
                                    <Link component="button" onClick={row.action.run}>
                                        {row.action.label}
                                    </Link>
                                ) : ''}
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell><b>Total Qty</b></TableCell>
                        <TableCell><b>{total}</b></TableCell>
                        <TableCell />
                    </TableRow>
                </TableBody>
            </Table>
        </React.Fragment>
    );
};

export default InventoryTable;
